@if (headerData || countrySelectorModal) {
  <div
    class="header__links-container"
    [ngClass]="{
      'hide-on-mobile': hideHeaderLinks
    }"
  >
    @if (countrySelectorModal) {
      <dotcom-frontend-loader
        [parent]="'headerLinks'"
        [cssClass]="'header__link-country-selector header__link'"
        [componentData]="countrySelectorModal"
        role="menuitem"
      />
    }
    @for (headerLink of headerData; let i = $index; track i) {
      <dotcom-frontend-button
        [data]="{
          href: headerLink.href,
          buttonStyle: headerLink.buttonStyle,
          text: headerLink.text,
          icon: headerLink.icon,
          target: headerLink.target,
          adobeData: {
            interactionContainer: 'Header Block',
            interactionLink: headerLink['href'],
            interactionName: headerLink['text'],
            interactionPage: pageTitle,
            interactionRegion: '',
            interactionType: 'ButtonClick',
            interactionDetails: ''
          }
        }"
        [tabIndex]="tabIndex"
        class="header__link"
        role="menuitem"
      />
    }
  </div>
}
